import React, { useState, useEffect } from "react";
import { Column, Text } from "@amzn/meridian";
import StepRenderer from "../StepRenderer";
import { useAppDispatch } from "src/store/store";
import { setCurrentIterateStep, setIterationProgress } from "src/store/workflowSlice";
import { setScannedBarcode } from "src/store/inspectionCaptureSlice";

interface IterateStepProps {
  iterateSteps: any[];
  drumCount: number | null;
  onIterateComplete: () => void;
}

const IterateStep: React.FC<IterateStepProps> = ({
  iterateSteps,
  drumCount,
  onIterateComplete,
}) => {
  const dispatch = useAppDispatch();
  const [currentIteration, setCurrentIteration] = useState(0);
  const [currentStepIndex, setCurrentStepIndex] = useState(0);

  // If drum count is not set yet, we can't iterate
  if (drumCount === null || drumCount === 0) {
    return (
      <Column alignmentVertical="center" alignmentHorizontal="center">
        <Text type="h200">Waiting for drum count...</Text>
      </Column>
    );
  }

  const currentStep = iterateSteps[currentStepIndex];
  
  // Update Redux with the current iterate step whenever it changes
  useEffect(() => {
    dispatch(setCurrentIterateStep(currentStep));
  }, [currentStepIndex, dispatch, currentStep]);

  // Update Redux with iteration progress
  useEffect(() => {
    dispatch(setIterationProgress({
      currentIndex: currentIteration,
      total: drumCount
    }));
  }, [currentIteration, drumCount, dispatch]);

  const handleStepComplete = () => {
    // Move to next step in the iteration
    if (currentStepIndex < iterateSteps.length - 1) {
      setCurrentStepIndex(currentStepIndex + 1);
    } else {
      // Completed all steps in this iteration
      if (currentIteration < drumCount - 1) {
        // Move to next iteration
        setCurrentIteration(currentIteration + 1);
        setCurrentStepIndex(0);
      } else {
        // Completed all iterations
        dispatch(setScannedBarcode(null));
        onIterateComplete();
      }
    }
  };

  return (
    <Column>
      <StepRenderer
        step={currentStep}
        drumCount={drumCount}
        onStepComplete={handleStepComplete}
      />
    </Column>
  );
};

export default IterateStep;
